const buildUDSConfigForWalletManager = function () {
  let currentConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let data = arguments.length > 1 ? arguments[1] : undefined;
  const config = {
    ...currentConfig,
    ...data
  };

  // Wallet Manager doesn't need to track modal states
  delete config.myWallet;
  return config;
};
export { buildUDSConfigForWalletManager as default };
